import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

function CreateUsernamePage() {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await api.put('/api/users/me', { username }); // <-- add /api if your backend uses it!
      navigate('/dashboard');
    } catch (err) {
      const msg = err.response?.data?.message || 'An error occurred.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h3>Create Your Username</h3>
        <p>Please create a unique username to continue using the application.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              minLength={4}
              autoFocus
              aria-describedby="username-help"
            />
            <small id="username-help">
              Minimum 4 characters. Allowed: - _ | ! . @ # $ &lt; &gt; + ( ) = *
            </small>
          </div>

          {error && <p className="error-message" aria-live="assertive">{error}</p>}

          <button type="submit" className="action-button" disabled={loading}>
            {loading ? 'Saving...' : 'Save Username'}
          </button>
        </form>
        <Link to="/forgot-username" className="forgot-link">
          Forgot Username?
        </Link>
      </div>
    </div>
  );
}

export default CreateUsernamePage;
